import type { MovementBehavior } from './MovementBehavior';
import { ChaseBehavior } from './ChaseBehavior';
import { JumpBehavior } from './JumpBehavior';
import { DriftingChaseBehavior } from './DriftingChaseBehavior';
import { RandomZigzagBehavior } from './RandomZigzagBehavior';
import { WolfBehavior } from './WolfBehavior';
import { ChargingBossBehavior } from '../boss-behaviors/ChargingBossBehavior';

const factories: Record<string, () => MovementBehavior> = {
  chase: () => new ChaseBehavior(),
  jump: () => new JumpBehavior(),
  drifting_chase: () => new DriftingChaseBehavior(),
  random_zigzag: () => new RandomZigzagBehavior(),
  wolf: () => new WolfBehavior(),
  charging_boss: () => new ChargingBossBehavior(),
};

export function createBehavior(name: string): MovementBehavior {
  const factory = factories[name];
  if (!factory) throw new Error(`Unknown movement behavior: ${name}`);
  return factory();
}
